import PropsDecoratorProvider, { PropsDecoratorContext } from './PropsDecoratorProvider';
import createSubstyle from './createSubstyle';
import defaultPropsDecorator from './defaultPropsDecorator';
import inline from './inline';
import useStyles from './useStyles';
export { createSubstyle, PropsDecoratorProvider, PropsDecoratorContext, defaultPropsDecorator, inline };
export default useStyles;


//////////////////
// WEBPACK FOOTER
// ./node_modules/substyle/es6/index.js
// module id = 301
// module chunks = 0